import api from "./axiosInstance";

const API = `${process.env.REACT_APP_API_URL}/Dashboard`;

const dashboardService = {
  getNotifications: async () => (await api.get(API)).data,
  getStats:         async () => (await api.get(`${API}/stats`)).data,
  getThroughput:    async () => (await api.get(`${API}/throughput`)).data,
  getNotices:       async (page = 1, pageSize = 20, { unreadOnly = false } = {}) =>
    (await api.get(`${API}/notices`, { params: unreadOnly ? { page, pageSize, unreadOnly } : { page, pageSize } })).data,
  createNotice:     async (notice) => (await api.post(`${API}/notices`, notice)).data,
  markRead:         async (noticeId) => api.put(`${API}/notices/${noticeId}/read`),
  markAllRead:      async () => api.put(`${API}/notices/read-all`),
  deleteNotice:     async (noticeId) => api.delete(`${API}/notices/${noticeId}`),
  getActiveOrders:  async (limit = 200) =>
    (await api.get(`${API}/orders`, { params: { limit } })).data,
};

export default dashboardService;
